import React, { Fragment, useState } from "react";
import { CustomChip } from "../../../components/chip/Chip";
import { Box, Grid, CardContent, Card } from '@mui/material';
import PropTypes from 'prop-types';
import { DireccionRI } from "./DireccionRI";
import './indicaciones.scss';

export const DireccionContent = ({ notification, setApto }) => {
    const [notificationData, setNotificationData] = useState(notification || {});

    function ItemR(props) {
        const { sx, ...other } = props;
        return (
            <Box
                sx={{
                    bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
                    color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
                    borderRadius: 0,
                    fontSize: '0.75rem',
                    ...sx,
                    padding: 1
                }}
                {...other}
            />
        );
    }

    ItemR.propTypes = {
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
            ),
            PropTypes.func,
            PropTypes.object,
        ]),
    };

    const [childrenAction, setChildrenAction] = useState(null);


    return <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
        <CardContent>
            <label className={`step-form-section-title ${childrenAction ? 'with-children-action' : ''}`}>
                <strong> Información del RI </strong>
                {Boolean(childrenAction) && <div>
                    {childrenAction}
                </div>}
            </label>
            <DireccionRI
                idDatosGenerales={notificationData?.idDatosGenerales}
                setChildrenAction={setChildrenAction}
                setApto={setApto}
            />
        </CardContent>
    </Card>
}
